import { Link } from 'react-router-dom';
import { Target, Heart, Shield, Briefcase } from 'lucide-react';

export default function About() {
  return (
    <>
      <div className="page-header">
        <h1>About CareerQuess</h1>
        <p>Your trusted partner in career growth and recruitment</p>
        <div className="breadcrumb">
          <Link to="/">Home</Link> / <span>About Us</span>
        </div>
      </div>
      <div className="about-content">
        <div className="about-grid">
          <div className="about-text">
            <h2>Connecting Talent with Opportunity</h2>
            <p>CareerQuess is a leading recruitment and placement agency dedicated to bridging the gap between talented professionals and top employers across India.</p>
            <p>With years of experience in the HR and recruitment industry, we work with over 500 companies and organizations in Delhi NCR and beyond, providing comprehensive placement consulting, HR solutions, and manpower recruitment services.</p>
            <p>Our mission is to empower job seekers with the right opportunities and help organizations find the perfect talent to drive their growth.</p>
          </div>
          <div className="about-image">
            <Briefcase size={120} color="#2563eb" strokeWidth={1} />
          </div>
        </div>
        <div className="section-header">
          <div className="badge">Our Values</div>
          <h2>What Drives Us</h2>
        </div>
        <div className="values-grid">
          <div className="value-card">
            <div className="value-icon"><Target size={24} /></div>
            <h3>Precision Matching</h3>
            <p>We carefully match candidates with roles that align with their skills, experience, and career goals.</p>
          </div>
          <div className="value-card">
            <div className="value-icon"><Heart size={24} /></div>
            <h3>Candidate First</h3>
            <p>Every job seeker deserves personalized attention and guidance throughout their career journey.</p>
          </div>
          <div className="value-card">
            <div className="value-icon"><Shield size={24} /></div>
            <h3>Trust & Integrity</h3>
            <p>We maintain the highest standards of professionalism and transparency in all our interactions.</p>
          </div>
        </div>
      </div>
    </>
  );
}
